import { Component } from '@angular/core';

@Component({
    selector: 'app-activity-conversation-report',
    templateUrl: './activity-conversation-report.component.html',
    styleUrl: './activity-conversation-report.component.scss',
    standalone: false
})
export class ActivityConversationReportComponent {

}
